jQuery( document ).on( "page.ready", function () {
  $ = jQuery;

  if ( $( "main.science" ).length ) {
    var smcontroller = new ScrollMagic.Controller();

    if ( $( window ).width() < 950 ) {

      var smcontroller = new ScrollMagic.Controller();​
      $( ".study-card" ).each( function () {
        var me = $( this );
        var cardAnim = new ScrollMagic.Scene( {
            triggerElement: this,
            triggerHook: .95
          } )
          .on( "start", function ( event ) {
            $( me ).addClass( "show" );
          } )
          .addTo( smcontroller );
      } );​

    } else {
      $( '.study-card' ).each( function () {
        var me = $( this ),
          pinItem = $( this ).children().children( '.top' ),
          pinHeight = ( $( pinItem ).height() * 0.78 ),
          height = ( $( this ).height() - pinHeight );

        new ScrollMagic.Scene( {
            triggerElement: this,
            triggerHook: 0.5,
            duration: height
          } )
          //.addIndicators()
          .on( "start", function ( event ) {
            $( me ).addClass( "show" );
          } )
          .setPin( pinItem[ 0 ] )
          .addTo( smcontroller );
      } );
    }
  }
} );